


import React from "react";
import Frame from "../../assests/Frame.png";
import heartLoading from "../../assests/heartLoading.gif";
import Tooltip from "@mui/material/Tooltip";
import { Search } from "lucide-react";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { ChevronLeft, ChevronRight } from "@mui/icons-material";



const Tables = ({
  tableData = [],
  pagination = {},
  onPageChange,
  onExport,
  loading = false,
  error = null,
  searchTerm,
onSearchChange,
onColumnFiltersChange, 
}) => {
  const [columnSearch, setColumnSearch] = React.useState({
  ruleId: "",
  ruleName: "",
  description: "",
  dqDimension: "",
  checkType: "",
  rulePhase: "",
  category: "",
  threshold: "",
  remediationAction: "",
  owner: "",
  status: "",
  allsearch: "",
  keywords:"",
});
const [isSearching,setIsSearching]=React.useState(false)
const tableContainerRef = React.useRef(null);


const highlightMatch = (text = "", searchTerm = "") => {
  if (!searchTerm.trim()) return text;

  const regex = new RegExp(`(${searchTerm})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    regex.test(part) ? (
      <span
        key={i}
        style={{
          backgroundColor: "orange",
          borderRadius: "2px",
          padding: "0 2px",
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

  const currentPage = pagination?.currentPage ?? 1;
  const pageSize = pagination?.pageSize ?? 10;
  const totalRecords = pagination?.totalRecords ?? tableData.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  const indexOfFirstRow = (currentPage - 1) * pageSize;
  const indexOfLastRow = Math.min(indexOfFirstRow + pageSize, totalRecords);
  const currentData = tableData.slice(indexOfFirstRow, indexOfLastRow);

  const gotoPage = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange && onPageChange(page);
  };
  React.useEffect(() => {
  setIsSearching(loading);
}, [loading]);


 

  return (
    <div className="poppins-regular">
      {/* Export Button */}
     {/* Export Button */}
{/* Export Button */}
<div className="flex justify-between items-center">
  {/* Left side items */}
  <div className="flex items-center gap-3">
    {/* Search Input */}
    <div className="relative w-[200px] mt-[6px] flex-shrink-0">
      <input
        type="text"
        className="text-[9px] placeholder-gray-400 py-2 pl-[10px] w-full outline-none border border-gray-500 rounded"
        placeholder="Search..."
        value={columnSearch.allsearch}
        onChange={(e) => {
          const value = e.target.value;
          setColumnSearch({ ...columnSearch, allsearch: value });
          setIsSearching(true);
          onSearchChange(value);
          setTimeout(() => setIsSearching(false), 8000);
        }}
      />

      {/* Search Icon */}
      <Search
        size={14}
        color="#9CA3AF"
        className="absolute right-[8px] top-1/2 -translate-y-1/2 pointer-events-none"
      />
    </div>

    {/* Reset button */}
    <button className="px-3 mt-[4px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
    onClick={() => {
    const clearedFilters = {
      ruleId: "",
      ruleName: "",
      description: "",
      dqDimension: "",
      checkType: "",
      rulePhase: "",
      category: "",
      threshold: "",
      remediationAction: "",
      owner: "",
      status: "",
      allsearch: ""
    };

    setColumnSearch(clearedFilters);      
    onSearchChange("");                  
    onColumnFiltersChange(clearedFilters); 
  }}>
      Reset
    </button>

    {/* Scroll section */}
 <div className="flex items-center gap-1 mt-[2px]">
  <ChevronLeft
  title="Scroll Left"
    className="cursor-pointer"
    onClick={() => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
      }
    }}
  />
  <p className="text-[12px]">Scroll</p>
  <ChevronRight
    className="cursor-pointer"
    title="Scroll Right"
    onClick={() => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }}
  />
</div>

  </div>

  {/* Right side - Export */}
  <div
    className="flex gap-1 items-center mb-2 cursor-pointer pt-[10px] pr-[10px]"
    onClick={onExport}
  >
    <img src={Frame} alt="Export icon" />
    <p className="text-[#bb1ccc]">Export Data</p>
  </div>
</div>




<div
  ref={tableContainerRef}
  style={{ overflowX: "auto", scrollBehavior: "smooth" }}
>   
{/* <table className="rules-tables" style={{ marginTop: "2rem", tableLayout: "fixed", width: "100%" }}> */}

   <table className="rules-tables" style={{ marginTop: "2rem" }}>
        <thead>
          <tr>
            <th  className="text-left  pb-0" style={{fontSize:"10px",textTransform: "none"}}>Rule ID</th>
            <th  className="text-left  pb-0" style={{fontSize:"10px",textTransform: "none"}}>Rule Name</th>
            <th  className="text-left  pb-0" style={{fontSize:"10px",textTransform: "none"}}>Description</th>
            <th  className="text-left  pb-0 whitespace-nowrap"style={{fontSize:"10px",textTransform: "none"}}>DQ Dimension</th>
                        <th  className="text-left  pb-0 whitespace-nowrap"style={{fontSize:"10px",textTransform: "none"}}>Keywords</th>
            <th  className="text-left  pb-0 whitespace-nowrap"style={{fontSize:"10px",textTransform: "none"}}>Check Type</th>
            <th  className="text-left  pb-0"style={{fontSize:"10px",textTransform: "none"}}>Rule Phase</th>
            <th  className="text-left  pb-0"style={{fontSize:"10px",textTransform: "none"}}>Category</th>
            <th className="text-left  pb-0"style={{fontSize:"10px",textTransform: "none", width:"220px"}}>Threshold</th>
            <th  className="text-left  pb-0 whitespace-nowrap"style={{fontSize:"10px",textTransform: "none"}}>Remediation Action</th>
            <th  className="text-left  pb-0"style={{fontSize:"10px",textTransform: "none"}}>Owner</th>
                        <th  className="text-left  pb-0"style={{fontSize:"10px",textTransform: "none"}}>Status</th>

          </tr>
    
  <tr>
  <th>
        <input
      className="text-[9px] placeholder-gray-400 rounded pl-2 py-2 w-full outline-none border-none"
      placeholder="Search"
      value={columnSearch.ruleId}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, ruleId: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onSearchChange(value);
        onColumnFiltersChange(updated); 
      }}
    />

  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search"
      value={columnSearch.ruleName}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, ruleName: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
   <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.description}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, description: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.dqDimension}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, dqDimension: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>
  <th>
    <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search"
      value={columnSearch.keywords}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, keywords: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
   <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search  "
      value={columnSearch.checkType}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, checkType: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 py-2 rounded pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.rulePhase}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, rulePhase: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 rounded py-2 pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.category}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, category: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
  <input
      className="text-[9px] placeholder-gray-400 py-2 rounded pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.threshold}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, threshold: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 pl-2 py-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.remediationAction}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, remediationAction: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
    <input
      className="text-[9px] placeholder-gray-400 py-2 pl-1 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.owner}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, owner: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>

  <th>
      <input
      className="text-[9px] placeholder-gray-400 py-2 pl-2 w-full outline-none border-none"
      placeholder="Search "
      value={columnSearch.status}
      onChange={(e) => {
        const value = e.target.value;
        const updated = { ...columnSearch, status: value };
        setColumnSearch(updated);
        setIsSearching(true);
        onColumnFiltersChange(updated);
      }}
    />
  </th>
</tr>
          
        </thead>
        <tbody>
  {isSearching ? (
  [...Array(10)].map((_, i) => (
    <tr key={i} style={{ height: "35px" }}>
      {[
        "250px", // Rule ID
        "130px", // Rule Name
        "200px", // Description
        "130px", // DQ Dimension
        "70px", // Check Type
        "100px", // Rule Phase
        "100px",//keyowrds
        "100px", // Category
        "130px", // Threshold
        "130px", // Remediation Action
        "100px", // Owner
        "70px", // Status
      ].map((width, j) => (
        <td key={j} style={{ padding: "10px", height: "35px" }}>
          <Skeleton
            variant="text"
            height={20}
            style={{ width }}
          />
        </td>
      ))}
    </tr>
  ))
) :  

          tableData.length > 0 ? (
            tableData.map((rule, index) => (
<tr
  key={index}
   style={{ backgroundColor: index % 2 === 0 ? "white" : "#eee" }}
   className="w-full"
>                {/* <td className="text-left align-middle line-clamp-1  break-words ">{rule.ruleId}</td> */}

<td className="text-left align-middle w-[160px]" style={{ fontSize: "10px" }}>
  <Tooltip
    title={rule.ruleId || ""}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "10px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
        },
      },
    }}
  >
  <span className="block font-poppins text-[10px] truncate w-[160px]">
  {highlightMatch(
    (() => {
      const text = rule.ruleId || "";
      const words = text.trim().split(/\s+/).filter(Boolean);
      return words.length > 15
        ? words.slice(0, 15).join(" ") + "..."
        : text;
    })(),
    columnSearch.ruleId || columnSearch.allsearch
  )}
</span>
  </Tooltip>
</td>




 <td className="text-left align-middle" style={{ Width: "180px",fontSize:"10px" }}>
  <Tooltip
    title={
      rule.ruleName?.includes("|")
        ? rule.ruleName.split("|")[1]?.trim()
        : rule.ruleName || ""
    }
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "12px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
        },
      },
    }}
  >
    <span className="block font-poppins w-[130px] text-[10px] truncate">
      {highlightMatch(
        (() => {
          const text = rule.ruleName?.includes("|")
            ? rule.ruleName.split("|")[1]?.trim()
            : rule.ruleName || "";
          const words = text.split(/\s+/);
          return words.length > 5
            ? words.slice(0, 5).join(" ") + "..."
            : text;
        })(),
        columnSearch.ruleName || columnSearch.allsearch
      )}
    </span>
  </Tooltip>
</td>


                {/* <td className="text-left align-middle">{rule.description}</td> */}
       <td className="text-left align-middle w-[200px]" style={{fontSize:"10px"}}>
  <Tooltip
    title={rule.description || ""}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "12px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block font-poppins text-[10px] truncate w-[200px]">
      {highlightMatch(
        (() => {
          const text = rule.description || "";
          const words = text.split(/\s+/);
          return words.length > 5
            ? words.slice(0, 5).join(" ") + "..."
            : text;
        })(),
        columnSearch.description || columnSearch.allsearch
      )}
    </span>
  </Tooltip>
</td>


                

<td
  className="text-left align-middle "
  style={{ fontSize: "10px" }}
>
  <div className="overflow-x-auto  w-[130px] whitespace-nowrap">
    {highlightMatch(
      (rule.dqDimension || "").charAt(0).toUpperCase() + 
      (rule.dqDimension || "").slice(1).toLowerCase(),
      columnSearch.dqDimension || columnSearch.allsearch
    )}
  </div>
</td>
<td className="text-left align-middle w-[100px]" style={{ fontSize: "10px" }}>
  <Tooltip
    title={
      Array.isArray(rule.keywords) && rule.keywords.length > 0
        ? rule.keywords.map(k => k.toLowerCase()).join(", ")
        : "N/A"
    }
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "12px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block font-poppins text-[10px] truncate w-[130px]">
      {highlightMatch(
        (() => {
          const text =
            Array.isArray(rule.keywords) && rule.keywords.length > 0
              ? rule.keywords.map(k => k.toLowerCase()).join(", ")
              : "N/A";
          const words = text.split(/\s+/);
          return words.length > 5
            ? words.slice(0, 10).join(" ") + "..."
            : text;
        })(),
        columnSearch.keywords || columnSearch.allsearch
      )}
    </span>
  </Tooltip>
</td>

<td className="text-left align-middle" style={{fontSize:"10px"}}>
  <div className="overflow-x-auto w-[80px] whitespace-nowrap ">
    {highlightMatch(
      rule.checkType
        ? rule.checkType.charAt(0).toUpperCase() + rule.checkType.slice(1)
        : "",
      columnSearch.checkType || columnSearch.allsearch
    )}
  </div>
</td>

<td className="text-left align-middle" style={{fontSize:"10px"}}>
  <div className="overflow-x-auto whitespace-nowrap w-[100px]">
    {highlightMatch(
      rule.rulePhase?.includes("|")
        ? rule.rulePhase.split("|")[1]?.trim()
        : rule.rulePhase || "",
      columnSearch.rulePhase || columnSearch.allsearch
    )}
  </div>
</td>

<td className="text-left align-middle w-[140px]" style={{fontSize:"10px"}}>
  <div className="overflow-x-auto whitespace-nowrap w-[100px]">
  {highlightMatch(rule.category || "", columnSearch.category || columnSearch.allsearch)}
  </div>
</td>     
<td className="text-left align-middle w-[150px]" style={{ fontSize: "10px" }}>
  {/* Threshold value (highlighted if matched) */}
  <div  className="overflow-x-auto  whitespace-nowrap w-[140px]" style={{fontSize:"10px"}} >
    {highlightMatch(rule.threshold?.toString() || "", columnSearch.threshold || columnSearch.allsearch)}
  </div>

  {/* Colored progress bar */}
 <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
  <div
    className="h-2 rounded-full transition-all duration-300"
    style={{
      width: `${parseFloat(rule.threshold) || 0}%`,
      backgroundColor:
        parseFloat(rule.threshold) > 95
          ? "#009F52"   
          : parseFloat(rule.threshold) > 90
          ? "#FFC100"   
          : "#FB0301",  
    }}
  ></div>
</div>
</td>
                {/* <td className="text-left align-middle"
                >
                  {rule.remediationAction}
                </td> */}
        <td className="text-left align-middle max-w-[250px] " style={{fontSize:"10px"}}>
  <Tooltip
    title={rule.remediationAction || ""}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "12px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block font-poppins text-[10px]  truncate w-[130px]" style={{fontSize:'10px'}}>
      {(() => {
        const text = rule.remediationAction || "";
        const truncated =
          text.split(/\s+/).length > 12
            ? text.split(/\s+/).slice(0, 12).join(" ") + "..."
            : text;

        // Apply orange background highlighting to truncated text
        return highlightMatch(truncated, columnSearch.remediationAction || columnSearch.allsearch);
      })()}
    </span>
  </Tooltip>
</td>


<td className="text-left align-middle" style={{fontSize:"10px"}}>
  <div className="w-[100px]">
  {highlightMatch(rule.owner || "", columnSearch.owner || columnSearch.allsearch)}
  </div>
</td>

<td className="text-left align-middle w-[70px]" style={{fontSize:"10px"}}>
  <div className="overflow-x-auto  whitespace-nowrap w-[100px]" style={{fontSize:"10px"}}>
    {rule.status}
  </div>
</td>              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: "center", padding: "1rem" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>

    
{totalRecords > 0 && (
  <div className="pagination mt-4 flex items-center justify-between">
    <span>
      Showing {indexOfFirstRow + 1} to {indexOfLastRow} of {totalRecords} entries
    </span>

    <div className="pagination-controls flex items-center gap-2">
      <button
        disabled={currentPage === 1}
        onClick={() => gotoPage(currentPage - 1)}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Previous
      </button>

      {(() => {
        const pageButtons = [];
        const maxPagesToShow = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = startPage + maxPagesToShow - 1;

        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        if (startPage > 1) {
          pageButtons.push(1);
          if (startPage > 2) pageButtons.push("...");
        }

        for (let i = startPage; i <= endPage; i++) {
          pageButtons.push(i);
        }

        if (endPage < totalPages) {
          if (endPage < totalPages - 1) pageButtons.push("...");
          pageButtons.push(totalPages);
        }

        return pageButtons.map((p, idx) =>
          p === "..." ? (
            <span key={idx} className="px-2 text-gray-500">...</span>
          ) : (
            <button
              key={idx}
              onClick={() => gotoPage(p)}
              className={`px-3 py-1 border rounded ${
                currentPage === p ? "bg-[#bb1ccc] text-white" : ""
              }`}
            >
              {p}
            </button>
          )
        );
      })()}

      <button
        disabled={currentPage === totalPages}
        onClick={() => gotoPage(currentPage + 1)}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        Next
      </button>
    </div>
  </div>
)}

    </div>
  );
};



export default Tables;
